<header class="sidebar">
    <div class="ui top fixed menu">
        <div class="ui container">
            <div class="item bf -reset -padding -border" routerLink="/">
                <img class="logo" src="../../assets/images/logo.png" alt="">
            </div>
            <div class="right item bf -reset -border full-menu">
                <a class="item bf -reset -background-hover -padding-rl" href="#work">How it
                    works</a>
                <a class="item bf -reset -background-hover -padding-rl" href="#choose">Why choose us</a>
                <a class="item bf -reset -background-hover -padding-rl" href="#universities">Universities</a>
<!--                <a class="item bf -reset -background-hover -padding-rl" href="#testimonials">Testimonials</a>-->
                <a class="item bf -reset -background-hover -padding-rl" href="#faq">FAQ</a>
                <button class="ui primary basic button" routerLink="{{'/search'}}">Find a course</button>
                <!-- <a class="item bf -reset -margin-right -background-hover -padding-rl loginLink" routerLink="{{'/login'}}">Login</a>
                <a class="item bf -reset -margin-right -background-hover -padding-rl loginLink" routerLink="{{'/profile'}}">profile</a> -->

            </div>
            <div class="right item bf -reset -border sidebar-btn">
                <i (click)="sidemenu()" class="fas fa-bars fa-2x" [ngClass]="{'fa-times':active == true}"></i>
            </div>
        </div>

        <div class="right menu">
            <div id="avatarMenu" class="ui top right pointing dropdown item"
                #dropdownAvatar>
                <div>
                    <i class="user tie icon" [ngStyle]="{'color': userData && userData.length > 0 ? '#00b5ad' : '' }"></i>
                </div>

                <div class="menu">
                    <div id="headerWrap">
                        <div>
                            <div>
                                <div>
                                    <div id="doc">
                                        {{ userData? userData[0].name : 'User Name' | uppercase }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="createSpace"></div>

                    <a class="item" *ngIf="!userData"
                    routerLink="{{'/login'}}">
                        <i class="user icon"></i>
                        Login
                    </a>

                    <a class="item" *ngIf="userData && userData.length === 1"
                    routerLink="{{'/profile'}}">
                        <i class="user icon"></i>
                        Profile
                    </a>

                    <a class="item" *ngIf="userData && userData.length === 1"
                    routerLink="{{'/profile/edit'}}">
                        <i class="user icon"></i>
                        Edit Profile
                    </a>

                    <a class="item"  *ngIf="userData && userData.length === 1" (click)="logout()">
                        <i class="sign out alternate icon"></i>
                        Sign Out
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-shadow" (click)="sidemenu()" [ngClass]="{'active':active == true}"></div>
    <div class="side-menu" [ngClass]="{'active':active == true}">
        <ul>
            <li>
                <a (click)="sidemenu()" class="item bf -reset -background-hover -padding-rl" href="#work">How it Works</a>
            </li>
            <li>
                <a (click)="sidemenu()" class="item bf -reset -background-hover -padding-rl" href="#choose">Why choose us</a>
            </li>
            <li>
                <a (click)="sidemenu()" class="item bf -reset -background-hover -padding-rl" href="#universities">Universities</a>
            </li>
<!--            <li>-->
<!--                <a (click)="sidemenu()" class="item bf -reset -background-hover -padding-rl" href="#testimonials">Testimonials</a>-->
<!--            </li>-->
            <li>
                <a (click)="sidemenu()" class="item bf -reset -background-hover -padding-rl" href="#faq">FAQ</a>
            </li>
        </ul>
        <button (click)="sidemenu()" class="ui primary basic button" routerLink="{{'/search'}}">Find a course</button>
    </div>
</header>

<router-outlet></router-outlet>

<footer>
    <div class="ui container">
        <div class="ui styled fluid accordion bf -reset -boxshadow -background">
            <div class="accordian-cont ui accordian">
                <div class="title d-flex justify-content-between">
                    <h5>Study Bridge</h5>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="content bf -reset -padding-rl">
                    <ul class="bf -reset -padding -margin">
                        <li>
                            <a class="item bf -reset -background-hover -padding" href="#work">How it works</a>
                        </li>
                        <li>
                            <a class="item bf -reset -background-hover -padding" href="#choose">Why choose us</a>
                        </li>
                        <li>
                            <a class="item bf -reset -background-hover -padding" href="#universities">Universities</a>
<!--                        </li>-->
<!--                        <li>-->
<!--                            <a class="item bf -reset -background-hover -padding" href="#testimonials">Testimonials</a>-->
<!--                        </li>-->
                        <li>
                            <a class="item bf -reset -background-hover -padding" href="#faq">FAQ</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="accordian-cont ui accordian">
                <div class="title d-flex justify-content-between">
                    <h5>Customer Service</h5>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="content bf -reset -padding-rl">
                    <ul class="bf -reset -padding -margin">
                        <li>
                            <p>P: 02-959-3694</p>
                        </li>
                        <li>
                            <p>F: 02-959-3694</p>
                        </li>
                        <li>
                            <p>E: hello@jobbridge.com</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="ui grid">
            <div class="eight wide tablet six wide computer column">
                <h1>StudyBridge</h1>
                <p>
                    StudyBridge Inc | CEO TOM | Vice CEO LUCAS No.513, 24, Kyungheedae-ro, Dongdaemun-gu, Seoul, Republic of Korea, Seoul, South Korea

                </p>
            </div>
            <div class="four wide column"></div>
            <div class="three wide column">
                <ul class="bf -reset -padding -margin">
                    <h5>Study Bridge</h5>
                    <li>
                        <a class="item bf -reset -background-hover -padding" href="#work">How it works</a>
                    </li>
                    <li>
                        <a class="item bf -reset -background-hover -padding" href="#choose">Why choose us</a>
                    </li>
                    <li>
                        <a class="item bf -reset -background-hover -padding" href="#universities">Universities</a>
                    </li>
<!--                    <li>-->
<!--                        <a class="item bf -reset -background-hover -padding" href="#testimonials">Testimonials</a>-->
<!--                    </li>-->
                    <li>
                        <a class="item bf -reset -background-hover -padding" href="#faq">FAQ</a>
                    </li>
                </ul>
            </div>
            <div class="three wide column">
                <h5>Customer Service</h5>
                <p>
                    P: 02-959-3694
                </p>
                <p>
                    F: 02-959-3694
                </p>
                <p>
                    E: hello@jobbridge.com
                </p>
            </div>
        </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui container">
        <div class="d-flex justify-content-between">
            <p>© 2022 Study Bridge ALL RIGHTS RESERVED</p>
            <div class="icons">
                <div class="icon-cont">
                    <a href="https://www.facebook.com/jobbridge.kr/" target="_blank"><i class="fab fa-facebook-f"></i></a>
                </div>
                <div class="icon-cont">
                    <a href="https://www.instagram.com/jobbridge.korea/" target="_blank"><i class="fab fa-instagram"></i></a>
                </div>
                <div class="icon-cont">
                    <a href="https://www.youtube.com/channel/UCnJUM_Pme4nXM25SyaIfWog" target="_blank"><i class="fab fa-youtube"></i></a>
                </div>
            </div>
        </div>
    </div>
</footer>


<ngx-spinner bdColor="rgba(0,0,0,0.8)" size="medium" color="#ffffff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Just Hold on, We are taking you There... </p>
</ngx-spinner>
